import { useQuery } from "react-query";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

export const useGetRuleFilterCategories = () => {
  const { filterCategoriesGet } = useCombinationRules();

  const { data, isLoading, isError } = useQuery({
    queryKey: [COMBINATION_RULES_QUERY_KEY, "filterCategories"],
    queryFn: () => filterCategoriesGet(),
  });

  return {
    categories: data?.data,
    isLoading,
    isError,
  };
};
